// 달력/시간표 공용 모션 규칙
//  - 한 칸 이동(이전/다음, 스와이프, 점프했지만 결과가 바로 옆 칸): 가로 슬라이드 — "옆으로 넘김"
//  - 두 칸 이상 점프, 보기 단계 전환(일 ↔ 월 ↔ 연): 페이드 + 살짝 확대 — "다른 곳으로 이동"
// 어떤 버튼을 눌렀는지가 아니라 실제 이동 거리로 고른다.
// OS "동작 줄이기"(prefers-reduced-motion) 사용자에게는 재생하지 않는다.

// 모션 종류: "left"(다음 칸이 오른쪽에서 들어옴) | "right"(이전 칸이 왼쪽에서 들어옴) | "zoom" | null
export function motionForDistance(diff) {
  if (diff === 0) return null;
  if (Math.abs(diff) === 1) return diff > 0 ? "left" : "right";
  return "zoom";
}

// 다음 모션 상태 — seq로 키프레임 이름을 번갈아 바꿔, 같은 모션이 연속돼도
// 내용이 바뀌는 바로 그 렌더에서 다시 재생되게 한다(한 프레임 비우는 방식은 깜빡임이 생긴다).
export function nextMotion(prev, type) {
  return { type, seq: (prev?.seq ?? 0) + 1 };
}

const KEYFRAMES = {
  left: { from: { transform: "translateX(100%)" }, to: { transform: "translateX(0)" } },
  right: { from: { transform: "translateX(-100%)" }, to: { transform: "translateX(0)" } },
  zoom: { from: { opacity: 0, transform: "scale(0.97)" }, to: { opacity: 1, transform: "scale(1)" } },
};
const TIMING = { left: "0.18s ease-out", right: "0.18s ease-out", zoom: "0.2s ease-out" };

// 컨테이너 sx — selector에 해당하는 요소들에 모션을 건다
export function motionSx(motion, selector) {
  const sx = {};
  for (const type of Object.keys(KEYFRAMES)) {
    sx[`@keyframes cal-${type}-0`] = KEYFRAMES[type];
    sx[`@keyframes cal-${type}-1`] = KEYFRAMES[type];
  }
  sx[selector] = {
    animation: motion?.type ? `cal-${motion.type}-${motion.seq % 2} ${TIMING[motion.type]}` : "none",
  };
  sx["@media (prefers-reduced-motion: reduce)"] = { [selector]: { animation: "none" } };
  return sx;
}
